import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Jobs() {
    return (
        <Default>
            <Head>
                <title>Spaarpunten actie</title>
                <link rel="canonical" href={route("points")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE en Jumbo Schijndel slaan hun handen om de inwoners van Schijndel en omstreken gezonder te laten leven. Klanten van de Jumbo Schijndel kunnen vanaf maandag 28 februari sparen voor een gratis personal training bij aankoop van groente en fruit."
                />
                <meta
                    property="og:description"
                    content="WE ARE en Jumbo Schijndel slaan hun handen om de inwoners van Schijndel en omstreken gezonder te laten leven. Klanten van de Jumbo Schijndel kunnen vanaf maandag 28 februari sparen voor een gratis personal training bij aankoop van groente en fruit."
                />
                <meta property="og:url" content={route("points")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Spaarpunten actie - WE ARE Personal Training Uden en Schijndel &amp; Jumbo Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl sm:text-7xl">
                        Spaarpunten actie
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="requirements"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Meer informatie
                        </Link>
                    </div>
                </Hero> */}

                <div className="relative p-32" id="requirements">
                    <div className="max-w-5xl mx-auto">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Algemene voorwaarden spaaractie:
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                Bij elke vijf euro aan groente en fruit ontvangt
                                u één spaarpunt.
                            </li>
                            <li className="text-gray-100">
                                Een volle spaarkaart met tien spaarpunten kunt u
                                inwisselen voor één gratis les samen met uw
                                vriend of vriendin.{" "}
                            </li>
                            <li className="text-gray-100">
                                Lessen kunnen alleen verzilverd en gevolgd
                                worden door personen ouder dan 18 jaar.{" "}
                            </li>
                            <li className="text-gray-100">
                                Lessen kunnen verzilverd worden tot uiterlijk 30
                                juni 2022.
                            </li>
                            <li className="text-gray-100">
                                Er worden maximaal vijf lessen per week gepland
                                voortgekomen uit deze actie. De lessen worden
                                ingepland op volgorde van aanvraag.{" "}
                            </li>
                            <li className="text-gray-100">
                                Er kan maximaal één gratis les per persoon
                                worden geclaimd. Het is niet mogelijk om
                                meerdere gratis lessen te volgen voortkomend uit
                                de spaaractie.{" "}
                            </li>
                            <li className="text-gray-100">
                                U dient de volle spaarkaart mee te nemen bij de
                                gratis les en in te leveren bij de
                                desbetreffende trainer.{" "}
                            </li>
                            <li className="text-gray-100">
                                Lessen worden ingepland in overleg met de
                                desbetreffende trainer op een geschikte dag en
                                tijd die voor beide partijen mogelijk is.{" "}
                            </li>
                            <li className="text-gray-100">
                                Door deelname bevestigt u dat u in goede
                                lichamelijke en geestelijke staat verkeert en
                                dat de u niet aan een aandoening lijdt die de
                                deelname zou kunnen beperken. Met het oog op
                                deelname ontheft u hierbij WE ARE van alle
                                claims, eisen of vorderingen volgend uit de
                                deelname of uit elk gebruik van de installaties,
                                conditie of trainingsapparatuur.{" "}
                            </li>
                            <li className="text-gray-100">
                                Het is voor u duidelijk dat u eventueel letsel
                                kunt oplopen en ontheft hierbij WE ARE van elke
                                aansprakelijkheid, nu en/of in de toekomst.{" "}
                            </li>
                            <li className="text-gray-100">
                                Trainingstijden zijn gereserveerd. Annuleringen
                                van afspraken wegens ziekte en/of andere
                                omstandigheden dienen uiterlijk 12 uur
                                voorafgaand aan de afspraak telefonisch kenbaar
                                te worden gemaakt aan één van de trainer. Een
                                afmelding via Whats app is niet geldig.{" "}
                            </li>
                            <li className="text-gray-100">
                                Annuleringen die minder dan 12 uur vooraf worden
                                gemaakt worden niet meer ingehaald. De gratis
                                les komt hierdoor te vervallen.{" "}
                            </li>
                            <li className="text-gray-100">
                                Trainingen en behandelingen worden geannuleerd
                                wanneer de klant minimaal 15 minuten te laat
                                voor de training is.
                            </li>
                            <li className="text-gray-100">
                                WE ARE is gerechtigd de algemene voorwaarde te
                                wijzigen.{" "}
                            </li>
                        </ol>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
